/**
 * Zod schema for `GET /api/dashboard/alerts`
 * (`apps/workers/src/api/pipelineAlerts.ts`), consumed by
 * `@/lib/api/apiClient`'s `usePipelineAlerts()` hook.
 *
 * GitHub issue "P1: No stale pipeline alerting — customers stuck for
 * weeks with no notification": backs the stale-pipeline warning
 * banner/badge on `@/pages/Dashboard.tsx`. Mirrors
 * `PipelineAlertResponseRow` (`apps/workers/src/api/pipelineAlerts.ts`) —
 * duplicated as a runtime-checkable Zod schema for the same reason
 * `./dashboardStats.ts`'s schema is (a shape drift throws at the query
 * boundary instead of silently rendering `undefined`).
 */

import { z } from 'zod';

export const pipelineAlertTypeSchema = z.enum([
  'zero_outreach_3d',
  'zero_reply_rate_10_sends',
  'pipeline_gap',
]);
export type PipelineAlertType = z.infer<typeof pipelineAlertTypeSchema>;

export const pipelineAlertRowSchema = z.object({
  id: z.string(),
  jobId: z.string(),
  jobTitle: z.string(),
  type: pipelineAlertTypeSchema,
  details: z.record(z.unknown()),
  createdAt: z.string(),
});
export type PipelineAlertRow = z.infer<typeof pipelineAlertRowSchema>;

export const pipelineAlertsResponseSchema = z.object({
  alerts: z.array(pipelineAlertRowSchema),
  scopedUserId: z.string(),
});
export type PipelineAlertsResponse = z.infer<typeof pipelineAlertsResponseSchema>;
